/**
 * @generated SignedSource<<789ef2b2ec581b32ca31c4e1ac8ee1f6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
export type MATOrganizationTypeEnum = "academy" | "private" | "school" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type MATOrganizationDescriptionList_matOrganization$data = {
  readonly created: any;
  readonly createdBy: string | null;
  readonly paymentCard: {
    readonly cardCompany: string;
    readonly cardNumber: string;
  } | null;
  readonly prefix: string;
  readonly title: string;
  readonly type: MATOrganizationTypeEnum;
  readonly " $fragmentType": "MATOrganizationDescriptionList_matOrganization";
};
export type MATOrganizationDescriptionList_matOrganization$key = {
  readonly " $data"?: MATOrganizationDescriptionList_matOrganization$data;
  readonly " $fragmentSpreads": FragmentRefs<"MATOrganizationDescriptionList_matOrganization">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "MATOrganizationDescriptionList_matOrganization",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "createdBy",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "created",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "prefix",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "MATPaymentCardInfo",
      "kind": "LinkedField",
      "name": "paymentCard",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cardCompany",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "cardNumber",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "MATOrganization",
  "abstractKey": null
};

(node as any).hash = "62b2b951b3ccbada0f75c5c313f19cb6";

export default node;
